import { initThreeJsCanvas } from './utils/init_canvas/init'
import {
  statusesUpdate,
  standingAreaStatusesUpdate,
  blocksStatusesUpdate
} from './utils/statusesUpdate'
import { drawMap } from './drawMap'
import { seats, standingAreas, blocks } from './utils/mapData'

const arrayToObject = (array) =>
  array.reduce((obj, item) => {
    obj[item.id] = item
    return obj
  }, {})

const activateGroups = (groups) => {
  for (const [seatId, seat] of Object.entries(seats)) {
    const [groupId] = seatId.split('-')
    if (!groups || groups.length === 0 || groups.includes(groupId)) {
      Array.isArray(seat)
        ? seat.forEach((e) => e.makeActive())
        : seat.makeActive()
    } else {
      Array.isArray(seat)
        ? seat.forEach((e) => e.makeDisabled())
        : seat.makeDisabled()
    }
  }
}

const recolorSeats = (seatsToRecolor, seatsToRecover = []) => {
  seatsToRecolor.forEach(({ seatId, color }) => {
    const meshes = seats[seatId]
    if (meshes && meshes.length) {
      meshes.forEach((meshItem) => {
        meshItem.allowColorUpdateByStatus = false
        meshItem.changeColor(color)
      })
    } else {
      seats[seatId].allowColorUpdateByStatus = false
      seats[seatId].changeColor(color)
    }
  })

  seatsToRecover.forEach(({ seatId }) => {
    const meshes = seats[seatId]
    if (meshes && meshes.length) {
      meshes.forEach((meshItem) => {
        meshItem.allowColorUpdateByStatus = true
        meshItem.setColorByStatus()
      })
    } else {
      seats[seatId].allowColorUpdateByStatus = true
      seats[seatId].setColorByStatus()
    }
  })
}

const createMap = async (
  container,
  seatmap,
  groups,
  creatorInfo,
  predefinedSeats,
  options
) => {
  groups = arrayToObject(groups)
  const {
    renderer,
    camera,
    scene,
    scale,
    fonts,
    cancelAnimation,
    controlsReset,
    controlsZoomIn,
    controlsZoomOut,
    startAnimation
  } = initThreeJsCanvas(container, options)
  await drawMap(seatmap, groups, creatorInfo, predefinedSeats, {
    ...options,
    scene,
    scale,
    fonts,
    renderer,
    camera
  })

  const updateStatuses = (statuses) => {
    standingAreaStatusesUpdate(statuses, standingAreas)
    return options.isBlockMap
      ? blocksStatusesUpdate(statuses, blocks)
      : statusesUpdate(statuses, seats)
  }
  if (!options.enableTicketTypeAssign) {
    updateStatuses(options.statuses)
  }

  return {
    activateGroups,
    recolorSeats,
    cancelAnimation,
    controlsReset,
    controlsZoomIn,
    controlsZoomOut,
    startAnimation,
    statusesUpdate: updateStatuses
  }
}

export { createMap }
